import { c as _c } from "react/compiler-runtime";
import ButtonBase from '@mui/material/ButtonBase';
import cx from 'classnames';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { getButtonLinkProps } from '@openclassrooms/routing';
interface Props {
  subTitle: string;
  path: string;
  children?: string;
  isActive?: boolean;
  onClick?: () => void;
  'data-event'?: string;
  'data-testid'?: string;
}
const RootBaseButton = styled(ButtonBase)(({
  theme: {
    radius,
    palette,
    breakpoints
  }
}) => {
  const baseColor = palette.background.paper;
  const unselectedHoverColor = palette.menu.background.unselected.hover;
  const selectedColor = palette.menu.background.selected.enabled;
  const selectedHoverColor = palette.menu.background.selected.hover;
  return {
    '--background-color': baseColor,
    '--icon-background-color': selectedColor,
    maxWidth: 336,
    width: '100%',
    justifyContent: 'flex-start',
    borderRadius: radius.banner,
    background: 'var(--background-color)',
    '&:hover': {
      '--background-color': unselectedHoverColor,
      '--icon-background-color': baseColor,
      color: palette.text.primary
    },
    '&.isActive': {
      '--background-color': selectedColor,
      '--icon-background-color': baseColor,
      color: palette.text.primary,
      '&:hover': {
        '--background-color': selectedHoverColor
      }
    },
    '&:focus-visible': {
      outline: `2px solid ${palette.brand.primary}`
    },
    [breakpoints.up('lg')]: {
      width: 336
    }
  };
}) as typeof ButtonBase;
const Inner = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  padding: spacing(1, 2)
}));
const noop = () => {};
export default function HeaderDropDownItem(t0) {
  const $ = _c(17);
  const {
    isActive,
    subTitle,
    path,
    children,
    onClick: t1,
    "data-event": dataEvent
  } = t0;
  const onClick = t1 === undefined ? noop : t1;
  let t2;
  if ($[0] !== path) {
    t2 = getButtonLinkProps(path);
    $[0] = path;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const linkProps = t2;
  let t3;
  if ($[2] !== isActive) {
    t3 = cx({
      isActive
    });
    $[2] = isActive;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <Typography variant="h5" component="div">{children}</Typography>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== subTitle) {
    t5 = <Typography variant="caption" color="textPrimary">{subTitle}</Typography>;
    $[6] = subTitle;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Inner>{t4}{t5}</Inner>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dataEvent || $[12] !== linkProps || $[13] !== onClick || $[14] !== t3 || $[15] !== t6) {
    t7 = <RootBaseButton {...linkProps} className={t3} data-event={dataEvent} onClick={onClick}>{t6}</RootBaseButton>;
    $[11] = dataEvent;
    $[12] = linkProps;
    $[13] = onClick;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}